var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiafitSzlogenNelkul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 589.23 308.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#010101;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 292.92,
    y1: 0,
    x2: 292.92,
    y2: 308.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fabd05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#e49209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#cf690e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#bf4a12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#b33314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ac2516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa2117"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 292.92,
    cy: 154.38,
    rx: 152.08,
    ry: 154.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m301.45,26.75l.2.35c.37.66.86,1.26,1.44,1.75,30.21,25.47,11.63,56.45,10.78,58.6-.86,2.16-1.85,1.79-1.85,1.79l-3.55-.76c-.19-.04-.38-.1-.55-.19-6.56-3.19-5.4-8.34-5.4-8.34l-.03-.11c4.27-2.33,7.31-8.24,7.31-15.17,0-8.96-5.08-16.23-11.35-16.23s-11.36,7.27-11.36,16.23c0,7,3.1,12.96,7.44,15.24,0,.09-.01.18-.02.28-.34,4.38-1.39,5.63-1.39,5.63-1.35,2.74-7.9,3.61-7.9,3.61-.91.1-1.01-.35-1.01-.35-19.22-34.61,4.11-55.8,9.57-60.12.72-.57,1.24-1.35,1.48-2.23h0s-.03-.06-.06-.05c-42.89,26.13-20.28,70.83-20.28,70.83,11.11,19.53,12.61,34.05,12.72,35.21l.02.16c3.56,20.33-8.5,25.01-10.07,25.53l-.36.15c-8.35,4.29-16.85,14.22-16.85,14.22-14.47,17.95-9.69,28.48-9.69,28.48,4.13,10.14,36.92,8.99,46.45,8.43,1.35-.08,2.54.89,2.72,2.24.69,5.04,2.68,13.61,2.69,13.66h0c4.77,29.65-1.95,53.58-2.74,56.26-.06.21.05.3.24.2,2.1-1.11,9.91-14.83,9.91-14.83,11.66-20.68,3.78-41.95,3.28-43.23-.02-.05-.03-.09-.05-.14-2.41-7.41.37-20.07.4-20.23h0s3.99-23.52,3.99-23.52c3.29-18.3-5.53-27.23-6.17-28.44,0-.02-.02-.03-.03-.05-7.99-24.43,9.8-52.17,9.8-52.17,5.29-7.43,6.46-16.04,6.46-16.04,6.94-40.15-23.96-55.58-26.15-56.69-.04-.02-.07.02-.05.06Zm-5.87,177.93c-18.72-1.43-27.9-4.23-28.82-4.52l-.15-.05c-5.75-2.22-2.77-6.14-2.77-6.14,11.96-16.74,25.55-19.73,31.45-20.19,1.46-.11,2.68,1.1,2.59,2.56-.39,5.94.08,19.96.3,25.85.06,1.49-1.11,2.6-2.6,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m238.49,68.16c-3.17-2.5-8.47-3.83-13.09-5.27-7.92-2.47-15.41-3.87-15.41-3.87,0,0,1.68,7.79,4.15,15.71,1.44,4.62,2.73,9.28,5.22,12.46,6.76,8.62,20.79,3.43,20.79,3.43l.1-.06c-1.27-.69-2.74-1.44-2.74-1.44-5.21-1.88-13.11-15.07-13.11-15.07,1.71.68,7.73,5.08,7.73,5.08,0,0,5,3.12,7.22,5.68,1.24,1.43,2.15,3.1,2.71,4.28.07-.16,6.09-13.3-3.56-20.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m366.72,87.23c2.5-3.17,3.83-8.47,5.27-13.09,2.47-7.92,3.87-15.41,3.87-15.41,0,0-7.79,1.68-15.71,4.15-4.62,1.44-9.28,2.73-12.46,5.22-8.62,6.76-3.43,20.79-3.43,20.79l.06.1c.69-1.27,1.44-2.74,1.44-2.74,1.88-5.21,15.07-13.11,15.07-13.11-.68,1.71-5.08,7.73-5.08,7.73,0,0-3.12,5-5.68,7.22-1.43,1.24-3.1,2.15-4.28,2.71.16.07,13.3,6.09,20.93-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m58.96,195.43H0v-82.11h22.64v71.68h36.32v10.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m115.62,195.43h-22.64v-82.11h22.64v82.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m235.75,156.14v1.08c-.08,3.19-.41,6.5-1,9.92-.59,3.42-1.42,6.84-2.48,10.26-1.07,3.42-2.34,6.81-3.82,10.15-1.48,3.35-3.15,6.55-4.99,9.61-1.85,3.06-3.83,5.93-5.96,8.61-2.13,2.68-4.37,5.05-6.73,7.1l-8.5-4.9c1.33-2.24,2.54-4.69,3.62-7.33,1.08-2.64,2.06-5.41,2.94-8.3.87-2.89,1.63-5.85,2.25-8.9.63-3.04,1.15-6.06,1.57-9.07.42-3,.73-5.96.94-8.87.21-2.91.32-5.67.32-8.3,0-2.05,0-4.38-.03-6.99-.02-2.6-.17-5.26-.46-7.95-.29-2.7-.75-5.33-1.4-7.9-.65-2.57-1.61-4.86-2.88-6.87-1.27-2.01-2.91-3.63-4.9-4.85-1.99-1.22-4.47-1.82-7.44-1.82-2.62,0-4.88.45-6.76,1.34-1.88.89-3.48,2.09-4.79,3.59-1.31,1.5-2.36,3.24-3.14,5.22-.78,1.98-1.39,4.06-1.82,6.24-.44,2.19-.72,4.39-.85,6.61-.14,2.22-.2,4.32-.2,6.3v15.91h24.58v9.41h-24.58v19.96h-22.64v-41.74c0-5.97.95-11.52,2.85-16.65,1.9-5.13,4.59-9.59,8.07-13.37,3.48-3.78,7.66-6.75,12.55-8.9,4.89-2.15,10.33-3.22,16.34-3.22,4.07,0,7.88.58,11.43,1.74,3.55,1.16,6.79,2.76,9.72,4.79,2.93,2.03,5.54,4.45,7.84,7.24,2.3,2.79,4.22,5.84,5.76,9.15,1.54,3.31,2.71,6.81,3.51,10.49.8,3.69,1.16,7.41,1.08,11.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m390.71,194.94h-22.88v-83h59.6v10.61h-36.72v25.65h28.36v10.55h-28.36v36.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m485.85,194.94h-22.88v-83h22.88v83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m566.63,194.94h-22.88v-72.39h-22.59v-10.61h68.07v10.61h-22.59v72.39Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiafitSzlogenNelkul);
export default __webpack_public_path__ + "static/media/liafit_szlogen_nelkul.7aea1d3554801a6a86316d0e27e3a308.svg";
export { ForwardRef as ReactComponent };